/**
 * Optimizes Contentful image URLs with compression and size parameters
 * @param {string} url - The Contentful image URL (with or without https:)
 * @param {object} options - Optimization options
 * @param {number} options.quality - Image quality (1-100), default 85
 * @param {number} options.maxHeight - Maximum height in pixels, default 1000
 * @param {string} options.format - Image format (jpg, png, webp), default 'jpg'
 * @returns {string} - Optimized image URL
 */
export function optimizeContentfulImage(url, options = {}) {
    if (!url) return '';
    
    const {
        quality = 85,
        maxHeight = 1000,
        format = 'jpg'
    } = options;
    
    // Ensure URL starts with https:
    const fullUrl = url.startsWith('https:') ? url : `https:${url}`;
    
    // Add Contentful image API parameters
    const params = new URLSearchParams({
        q: quality,
        h: maxHeight,
        fm: format,
        fit: 'scale' // Maintains aspect ratio
    });
    
    return `${fullUrl}?${params.toString()}`;
}
